import script from "./storageContractDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./storageContractDetail.vue?vue&type=script&setup=true&lang=js"

import "./storageContractDetail.vue?vue&type=style&index=0&id=24cd2902&lang=less"

const __exports__ = script;

export default __exports__